import _ from 'lodash';
import winston from 'winston';
import fetch from 'isomorphic-fetch';
import HttpError, {
  STATUS_CODE,
} from './HttpError';

export default async function fetchHelper(
  token: string,
  method: string,
  url: string,
  body?: object,
  customHeaders?: object,
): Promise<object | HttpError> {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...(customHeaders || {}),
    },
    method,
    body: body ? JSON.stringify(body) : undefined,
  };
  // eslint-disable-next-line functional/no-conditional-statement
  if (_.isEmpty(token)) {
    winston.error(`No Token ${method} ${url} with ${options}`);
    // eslint-disable-next-line functional/no-conditional-statement
  } else {
    // eslint-disable-next-line functional/immutable-data, functional/no-expression-statement
    (options.headers as any).Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  winston.debug(`${method} ${url}: ${JSON.stringify(options)}`);
  const response = await fetch(url, options);
  if (response.ok) {
    return response.json();
  }
  // eslint-disable-next-line functional/no-throw-statement
  throw new HttpError(response.status as STATUS_CODE);
}
